export default __webpack_public_path__ + "static/media/infiniteimagescroll.c02670f4.png";